import { useInView } from '../../../hooks/useInView';

interface InfoRow {
  label: string;
  value: string;
  icon: string;
}

const infoRows: InfoRow[] = [
  { label: '住所', value: '〒150-0001 東京都渋谷区神宮前 3-12-5 渋谷ハウス 2F', icon: 'ri-map-pin-line' },
  { label: '電話番号', value: '03-1234-5678', icon: 'ri-phone-line' },
  { label: '営業時間', value: '10:00 〜 20:00（最終受付 19:00）', icon: 'ri-time-line' },
  { label: '定休日', value: '毎週水曜日・不定休', icon: 'ri-calendar-line' },
  { label: '駐車場', value: '近隣コインパーキングをご利用ください', icon: 'ri-car-line' },
  { label: 'アクセス', value: '地下鉄表参道駅 A2出口より徒歩4分', icon: 'ri-walk-line' },
];

export default function Access() {
  const { ref: titleRef, isInView: titleInView } = useInView<HTMLDivElement>();
  const { ref: contentRef, isInView: contentInView } = useInView<HTMLDivElement>({ threshold: 0.1 });

  return (
    <section id="access" className="py-20 sm:py-28 lg:py-36 bg-cream">
      <div className="max-w-6xl mx-auto px-6 sm:px-8">
        {/* Section title */}
        <div
          ref={titleRef}
          className="mb-12 sm:mb-16 transition-all duration-700"
          style={{
            opacity: titleInView ? 1 : 0,
            transform: titleInView ? 'translateY(0)' : 'translateY(32px)',
          }}
        >
          <p className="section-label mb-4">SALON &amp; ACCESS</p>
          <h2 className="font-serif-jp text-charcoal leading-snug" style={{ fontSize: 'clamp(28px, 5vw, 48px)' }}>
            サロン案内・
            <br className="sm:hidden" />
            アクセス
          </h2>
        </div>

        {/* Content grid */}
        <div
          ref={contentRef}
          className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-14 items-start transition-all duration-700"
          style={{
            opacity: contentInView ? 1 : 0,
            transform: contentInView ? 'translateY(0)' : 'translateY(32px)',
          }}
        >
          {/* Left: Info */}
          <div className="lg:col-span-2">
            <div className="mb-8">
              <h3 className="font-serif-jp text-charcoal font-medium mb-1" style={{ fontSize: 'clamp(18px, 2.5vw, 22px)' }}>
                プライベートサロン
              </h3>
              <p className="font-sans-jp text-gold" style={{ fontSize: '12px', letterSpacing: '0.15em' }}>
                Private Beauty Salon
              </p>
            </div>

            <div className="space-y-5">
              {infoRows.map((row) => (
                <div key={row.label} className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center">
                    <i className={`${row.icon} text-gold text-base`} />
                  </div>
                  <div>
                    <p className="font-sans-jp text-salon-gray mb-0.5" style={{ fontSize: '11px', letterSpacing: '0.15em' }}>
                      {row.label}
                    </p>
                    <p className="font-sans-jp text-charcoal" style={{ fontSize: 'clamp(13px, 1.8vw, 15px)', lineHeight: '1.6' }}>
                      {row.value}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Google Map */}
          <div className="lg:col-span-3">
            <div
              className="overflow-hidden shadow-sm"
              style={{ borderRadius: '4px', aspectRatio: '16/10' }}
            >
              <iframe
                title="サロンの地図"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.7476853064595!2d139.71060491525916!3d35.665160080197905!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188ca0b7f7c2c7%3A0x7b64d4e1dfbfe1f6!2z6KW_5YuV5YmN5ZCM5LiL55yM!5e0!3m2!1sja!2sjp!4v1620000000000!5m2!1sja!2sjp"
                width="100%"
                height="100%"
                style={{ border: 0, display: 'block', minHeight: '320px' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
